export default __webpack_public_path__ + "2ffae01c2ebcbf1f35cc9f287c8ed74a.png";